import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './index.css';

const  ModalNoti = ({show, onHide, closeButton, content, leftButton, rightButton}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className='noti_modal'
    >
      <Modal.Header className='header_noti_modal'>
        <div>
          Thông báo
        </div>
        {closeButton && <button className='close_button' onClick={onHide}>x</button>}
        
      </Modal.Header>
      <Modal.Body className='content_noti_modal'>
        {content}
      </Modal.Body>
      
      <div className='footer_noti_modal'>
        {leftButton && <Button className='left_button' onClick={leftButton.onClick}>{leftButton.content}</Button>}
        {rightButton && <Button className='right_button' onClick={rightButton.onClick}>{rightButton.content}</Button>}
      </div>
    </Modal>
  );
}

export default ModalNoti;